import { inject, Injectable, Injector } from "@angular/core";
import { doc, docSnapshots, Firestore } from "@angular/fire/firestore";
import { of } from "rxjs";
import { catchError, filter, map, shareReplay, switchMap } from "rxjs/operators";
import { BaseService } from "../app.base.service";
import { CommonService } from "../services/common/common.service";
import { AuthService } from "./auth.service";
import { CatchErrorService } from "./catch-error.service";
@Injectable({
  providedIn: "root",
})
export class SyndicateSummary extends BaseService {
  userId: string;
  private commonService = inject(CommonService)
  constructor(
    private firestore: Firestore,
    private injector: Injector,
    private catchService: CatchErrorService,
    private authService: AuthService
  ) {
    super(injector);
  }
  async ngOnInit() {
    await this.authService
      ?.getUid("SyndicateSummary")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
  }

  updateSyndicates() {
    if (!window.navigator.onLine) {
      return of(null);
    }
    return this.commonService.getUid("RequestSyndicateService").pipe(
      filter((userId) => !!userId && userId !== "null"),
      switchMap((userId) => {
        return this.authService.getV2CloudFunction("claimreferencev2", userId);
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }

  getSyndicateSummary(syndicate_name: string) {
    if (
      syndicate_name === "" ||
      syndicate_name === null ||
      this.userId === "null" ||
      this.userId === null ||
      !window.navigator.onLine
    ) {
      return;
    }

    return this.catchService.isOnline$.pipe(
      switchMap((isOnline) => {
        if (!isOnline) return null;

        const docRef = doc(
          this.firestore,
          `/users/${this.userId}/user_claim_ref/${syndicate_name}` // Firestore document reference
        );

        return docSnapshots(docRef).pipe(
          this.catchService.retryWhen,
          this.catchService.catchOfflineError
        );
      }),
      this.catchService.retryWhen,
      this.catchService.catchOfflineError,
      shareReplay(1)
    ).pipe(
      map((res: any) => res?.data()) // Updated mapping to access document data
    );
  }
}
